import React from 'react';
import { Box, createStyles, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ColumnHeaderCommon from '@components/SchedulePage/ColumnHeaderCommon/ColumnHeaderCommon';
import ColumnHeaderProps from '@components/SchedulePage/types/ColumnHeaderProps';
import {
	getBlockColumnHeaderDetails,
} from '@components/SchedulePage/utilities/getBlockColumnHeaderDetails/getBlockColumnHeaderDetails';

const useStyles = makeStyles(theme => createStyles({
	root: {
		padding: theme.spacing(0.25, 1, 0.5, 1),
		backgroundColor: theme.palette.secondary.dark,
		color: theme.palette.common.white,
		display: 'flex',
		flexDirection: 'column',
		borderRadius: '4px 4px 0 0',
	},
	nonBlockText: {
		fontSize: '0.875rem',
		fontWeight: 600,
	},
	nonBlockSection: {
		alignItems: 'center',
		display: 'flex',
		flexGrow: 1,
		marginTop: theme.spacing(.5),
		textTransform: 'unset',
	},
}));

type NonBlockColumnHeaderProps = ColumnHeaderProps;

const NonBlockColumnHeader: React.FC<NonBlockColumnHeaderProps> = ({ blockInfo }) => {
	const classes = useStyles();

	const { primaryTimeframes } = React.useMemo(() => getBlockColumnHeaderDetails(blockInfo), [blockInfo]);

	return (
		<Box className={classes.root} data-field="non-block-column-header" component="header">
			{primaryTimeframes.length > 0 && <ColumnHeaderCommon timeFrames={primaryTimeframes} />}
			<Box className={classes.nonBlockSection}>
				<Typography className={classes.nonBlockText}>Non-Block Time Only</Typography>
			</Box>
		</Box>
	);
};

export default NonBlockColumnHeader;
